import Head from 'next/head';
import React from 'react';
import { withLayout } from '../Layout/Layout';
import { OffersList } from '../components/OffersList/OffersList';

function TopLists() {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/cars`} />
      </Head>
      <OffersList heading="Offers" />
    </>
  );
}

export default withLayout(TopLists, false);
